<form class="admin-form" [formGroup]="announcementForm" (ngSubmit)="onSubmit()">
    <label for="title">Título
        <input id="title" type="text" formControlName="title" maxlength="50" />

        @if (announcementForm.get('title')?.invalid && announcementForm.get('title')?.touched) {
        <small class="error-text">Informe um título com até 50 caracteres.</small>
        }
    </label>

    <label for="image_url">URL da Imagem
        <input id="image_url" type="text" formControlName="image_url" placeholder="https://..." />

        @if (announcementForm.get('image_url')?.invalid && announcementForm.get('image_url')?.touched) {
        <small class="error-text">Informe uma URL de imagem válida.</small>
        }
    </label>

    <label for="deeplink">Link (deeplink)
        <input id="deeplink" type="text" formControlName="deeplink" placeholder="https://..." />

        @if (announcementForm.get('deeplink')?.invalid && announcementForm.get('deeplink')?.touched) {
        <small class="error-text">Informe uma URL válida.</small>
        }
    </label>

    @if (createAnnouncementError) {
    <small class="error-text">{{createAnnouncementError}}</small>
    }

    <div class="form-actions">
        <button type="submit" class="admin-btn admin-btn--primary" [disabled]="announcementForm.invalid || isCreatingAnnouncement">
            Criar Anúncio
        </button>
    </div>
</form>
